import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Returning from Google OAuth callback: let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    const t = localStorage.getItem("bitego_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setToken(null))
      .finally(() => setLoading(false));
  }, []);

  const login = (token, u) => { setToken(token); setUser(u); };
  const logout = () => { setToken(null); setUser(null); };
  const patchUser = (u) => setUser((p) => ({ ...p, ...u }));
  const refreshUser = async () => { try { const r = await api.get("/auth/me"); setUser(r.data); return r.data; } catch { return null; } };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, patchUser, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
